import { css } from '@emotion/react';
import type { WithTheme } from '@emotion/react';
import { themeGet } from 'styled-system';

export const outlineCSS = (props: WithTheme<object, object>) => css`
  outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')(props)};
`;

export const focusOutlineCSS = (props: WithTheme<object, object>) => css`
  &:focus-visible {
    outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')(props)};
  }
`;

export const outlineCSSWithOffset = (props: WithTheme<object, object>) => css`
  outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')(props)};
  outline-offset: 2px;
`;

export const outlineCSSWithInwardOffset = (props: WithTheme<object, object>) => css`
  outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')(props)};
  outline-offset: -2px;
`;

export const focusOutlineCSSWithOffset = (props: WithTheme<object, object>) => css`
  &:focus-visible {
    outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')(props)};
    outline-offset: 2px;
  }
`;

export const focusOutlineCSSWithInwardOffset = (props: WithTheme<object, object>) => css`
  &:focus-visible {
    outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')(props)};
    outline-offset: -2px;
  }
`;

export const focusOutlineCSSWithOffsetAndRadius = (props: WithTheme<object, object>) => css`
  &:focus-visible {
    outline: 2px solid ${themeGet('colors.sys.secondary.border.focus')(props)};
    outline-offset: 2px;
    border-radius: ${themeGet('radii.medium')(props)};
  }
`;

export const hoverOutlineCSSWithOffsetAndRadius = (props: WithTheme<object, object>) => css`
  outline-offset: 2px;
  border-radius: ${themeGet('radii.medium')(props)};

  &:hover {
    outline: 1px solid ${themeGet('colors.sys.neutral.border.hover')(props)};
  }

  &:active {
    outline: 1px solid ${themeGet('colors.sys.neutral.border.active')(props)};
  }
`;

export const hoverOutlineCSS = (props: WithTheme<object, object>) => css`
  &:hover {
    outline: 1px solid ${themeGet('colors.sys.neutral.border.hover')(props)};
  }

  &:active {
    outline: 1px solid ${themeGet('colors.sys.neutral.border.active')(props)};
  }
`;

export const textWithEllipsis = (lineClamp: number = 1) => css`
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lineClamp};
  ${lineClamp === 1 ? 'word-break: break-all;' : ''}
`;
